var Breakpoint;
(function (Breakpoint) {
  Breakpoint[Breakpoint["ZOOM_400"] = 320] = "ZOOM_400";
  Breakpoint[Breakpoint["EXTRA_SMALL"] = 480] = "EXTRA_SMALL";
  Breakpoint[Breakpoint["SMALL"] = 576] = "SMALL";
  Breakpoint[Breakpoint["MEDIUM"] = 768] = "MEDIUM";
  Breakpoint[Breakpoint["LARGE"] = 992] = "LARGE";
  Breakpoint[Breakpoint["EXTRA_LARGE"] = 1200] = "EXTRA_LARGE";
})(Breakpoint || (Breakpoint = {}));

export { Breakpoint };
//# sourceMappingURL=breakpoint.mjs.map
